import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getFullHttpUrl } from "../firebase.config";
import { EAST4 } from "./enums";

// The functions behind a page's buttons, started while the person is still
// looking at the page. A function nobody called for a few minutes has no
// instance running, and the first call waits for one to start: 6-7 s on
// "Remove card", "Set as primary" or "Remove member" (measured 2026-10-12,
// against 0.3 s once running). The functions answer `?warmup=true` at once,
// without signing in and without doing anything, so a ping when the page
// opens has them running by the time someone clicks.

const CARDS = ["stripe-detachPaymentMethod", "stripe-setDefaultCard", "stripe-setUpPaymentIntent", "stripe-saveSetupCard"];
const TEAM = ["team-removeMember", "team-inviteMember", "team-resendMemberInvitation", "team-revokeInvite",
  "team-deactivateMember", "team-reactivateMember", "team-createInviteLink"];
const CHAT = ["newChatMessage", "markChatRead"];
const PAY = ["stripe-createPaymentIntent", "payments-confirm", "payments-placeOnAccount", "balance-payOrder"];
const PAY_INVOICES = ["stripe-createPaymentIntent", "payments-confirm", "balance-payInvoice", "balance-payInvoices"];

// [the page's address, the functions it may call]
const PAGES = [
  [/^\/account\/(billing|settings)/, [...CARDS, "balance-createTopUp", "balance-confirmTopUp"]],
  [/^\/account\/team(-members)?\/?$/, TEAM],
  [/^\/account\/(order|quote)\//, [...CHAT, "payments-quoteOptions"]],
  [/^\/account\/(invoices|pay-invoices|invoice\/)/, PAY_INVOICES],
  [/^\/office\/(translations|quote)\//, CHAT],
  [/^\/office\/team\//, ["team-removeMember", "team-addMember"]],
  // Create manually > New Client: 6.6 s cold on "Continue to Details" (2026-10-24).
  [/^\/manualQuote\/create/, ["createPersonalUser"]],
  [/^\/order\/(options|contact|payment)/, [...PAY, "coupons-check"]],
];

const EAST4_FUNCTIONS = ["coupons-check", "emails-sendPaymentLink"];

// A function pinged in the last few minutes is still running.
const AGAIN_AFTER_MS = 5 * 60 * 1000;
const lastPing = {};

export const warmFunctions = (names) => {
  const now = Date.now();
  names.forEach((name) => {
    if (now - (lastPing[name] || 0) < AGAIN_AFTER_MS) {
      return;
    }
    lastPing[name] = now;
    try {
      const url = getFullHttpUrl(name, EAST4_FUNCTIONS.includes(name) ? EAST4 : undefined);
      // no-cors: the answer isn't read, only the start of the function matters.
      fetch(`${url}?warmup=true`, { method: "POST", mode: "no-cors", keepalive: true }).catch(() => {});
    } catch (e) {
      // nothing to do: the click will still work, only slower
    }
  });
};

// Mounted once inside the router (App.js).
export const FunctionWarmer = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PAGES.find(([path]) => path.test(pathname));
    if (page) {
      warmFunctions(page[1]);
    }
  }, [pathname]);
  return null;
};
